import { useParams } from "react-router-dom";
import TemplateEdit from "./TemplateEdit";

function TemplateEditPage() {
  const params = useParams();

  return (
    <>
      <div className="main-container-title">
        <h1>
          {params.name ? "Edit " : "Create "} Drawing Template{" "}
          {params.name ? <strong>{params.name}</strong> : ""}
        </h1>
      </div>
      <div className="main-container-content">
        {params.name && (
          <TemplateEdit drawingName={params.name} readOnly={false} />
        )}
      </div>
    </>
  );
}

export default TemplateEditPage;
